document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tabs_links");
    tabs.forEach(tab => {
      tab.addEventListener("click", () => {

        tabs.forEach((eachTab)=> eachTab.classList.remove('is--active'))
        
        tab.classList.add('is--active')
        const targetSectionId = tab.getAttribute("data-target");
        const targetSection = document.getElementById(targetSectionId);
        if (targetSection) {
          targetSection.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
});